import React from 'react';
import { VIP_BELOW_CTA } from '../../../brands/default/content/components/checkout';

const VipMessage = () => {
  return (
    <>
      <div className="vip-message">{VIP_BELOW_CTA}</div>
      <style jsx>{`
        .vip-message {
          font-size: 11px;
          margin: 5px;
          text-align: justify;
        }
      `}</style>
    </>
  );
};

export default VipMessage;
